<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>公司信息</el-breadcrumb-item>
      <el-breadcrumb-item>公司信息</el-breadcrumb-item>
    </el-breadcrumb>    
    <el-card>
      
      <!-- 表格 -->
      <el-row>
        <el-form
        style="width: 800px;"
       :model="userForm"
       :rules="userFormRules"
       ref="userFormRef"
       label-width="90px">
        <el-form-item label="展厅图">
          <el-upload
            class="upload-demo"
            action="#"
            :file-list="fileList"
            :on-remove="handleRemove"
            :before-upload="uploadImage1"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="工厂图">
          <el-upload
            class="upload-demo"
            action="#"
            :file-list="fileList2"
            :on-remove="handleRemove2"
            :before-upload="uploadImage2"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      
      
        <el-button  type="primary" @click="addUserBtn" size="small">保存</el-button>
        
      
      </el-row>   
    </el-card>
  </div>
</template>

<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<script>
import table from '@/mixins/tables'
import OSS from 'ali-oss';
export default {
  data () {
    var checkMobile = (rule, val , cb) => {
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
        if (regMobile.test(val)) {
          return cb()
        } else {
          cb(new Error('请输入合法手机号'))
        }
    }
    
    return {
      userTitle:'添加',
      userDialog: false,
      userForm: {
        userid:0,
        username: '',
        content:''
      },
      userFormRules: {
        username: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 120,
            message: '产品名长度在 1 到 120 个字符之间',
            trigger: 'blur'
          }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        content:[
          { required: true, message: '请输入公司详情', trigger: 'blur' },
        ],
        plote:[
          { required: true, message: '请输入车牌号', trigger: 'blur' },
        ]
      },  
      sexOptions: [{
          value: 0,
          label: '男'
        }, {
          value: 1,
          label: '女'
        }],
      typeOptions: [{
          value: 0,
          label: '区域管理员'
        }, {
          value: 1,
          label: '系统管理员'
        }],
      tableData: [ ],
      userCloumn: [
        { name: 'name', label: '名称', minWidth: '160px' }    
      ],  
      yanse:[],
      caizhi:[],
      xilie:[],
      guige:[],
      guangzedu:[],
      gongyi:[],
      fileList: [],
      fileList2: [],
      client:undefined,
      headers:undefined
    }
  },
  mixins: [table],
  created () {
    this.getList()
    this.loadClient()
  },
  methods: {
    getList() {
      var that = this;
      this.$post('/apis/manage/product/companyMsg',{
              token:sessionStorage.getItem('token')
          }).then(function(res){
            if(res.errno == 0){
              that.userForm.username = res.data.name
              that.fileList2 = res.data.content
              that.fileList = res.data.lb
            }else if(res.errno == 99){
              that.$message.info(res.errmsg);
              sessionStorage.clear();
              that.$router.push("/login");
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
      
    },
    loadClient(){
      // 配置OSS客户端
      this.client = new OSS({
        region: 'oss-cn-hangzhou',
        accessKeyId: 'LTAI5t7cyydtfHCta1dgFCuA',
        accessKeySecret: 'x0lQnzUbb7tQscZ0nVpxndoNv1yUu7',
        bucket: 'zxcl',
      });
      // 自定义请求头
      this.headers = {
        // 指定Object的存储类型。
        'x-oss-storage-class': 'Standard',
        // 指定Object的访问权限。
        'x-oss-object-acl': 'public-read-write',
        // 通过文件URL访问文件时，指定以附件形式下载文件，下载后的文件名称定义为example.txt。
        'Content-Disposition': 'inline',
        // 设置Object的标签，可同时设置多个标签。
        'x-oss-tagging': 'Tag1=1&Tag2=2',
        // 指定PutObject操作时是否覆盖同名目标Object。此处设置为true，表示禁止覆盖同名Object。
        'x-oss-forbid-overwrite': 'false',
      };

    },
    addUserBtn() {
      this.$refs.userFormRef.validate( valid => {
        if (valid) {
          var that = this;
          this.$post('/apis/manage/product/addCompany',{
              username:this.userForm.username,
              token:sessionStorage.getItem('token'),
              lb:JSON.stringify(this.fileList),
              content:JSON.stringify(this.fileList2)
          }).then(function(res){
            if(res.errno == 0){
              that.$message.success('公司信息编辑成功');
              that.userDialog = false;
              that.getList();
            }else{
              that.$message.info(res.errmsg);
            }
          }).catch(function(err){
            window.console.log(err);
          });
        }
      }) 
    },
    
    async uploadImage1(file) {
      console.log('上传图片1');
      console.log(file);
      let that = this
      //const file = event.target.files[0];
      if (!file) return;
      try {
       
      // 自定义请求头
      let headers = that.headers
        // 上传图片
        console.log('上传图片1');
        let now = Date.now()
        let newName = now +'_'+ file.name
        const result = await this.client.put(newName, file,{headers});
        console.log(result);
        if(result.name != undefined && result.name != ''){
          that.fileList.push(
            {name:result.name,url:result.url}
          )
          //that.userForm.imageUrl = result.url
        }
      } catch (e) {
        console.error(e);
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      //console.log(file, fileList,this.fileList);
    },
    handleRemove2(file, fileList) {
      this.fileList2 = fileList
      //console.log(file, fileList,this.fileList);
    },
    async uploadImage2(file) {
      console.log('上传图片2');
      console.log(file);
      let that = this
      //const file = event.target.files[0];
      if (!file) return;
      try {
        // 上传图片
        let headers = that.headers
        console.log('上传图片2');
        let now = Date.now()
        let newName = now +'_'+ file.name
        const result = await this.client.put(newName, file,{headers});
        console.log(result);
        if(result.name != undefined && result.name != ''){
          that.fileList2.push(
            {name:result.name,url:result.url}
          )
          //that.userForm.imageUrl = result.url
        }
      } catch (e) {
        console.error(e);
      }
    },
  }
}
</script>
<style>
textarea{
  min-height: 306px;
}
 
</style>